import React, { useState, useEffect, useCallback } from "react";

import { producaov2 as api } from "../../../../services/apis";
import { toast } from "react-toastify";

import Menu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { convertDate } from "../../../../utils/Utils";

import { FaSearch } from "react-icons/fa";
import {
  Container,
  SearchBarBox,
  PeriodContainer,
  SearchInput,
  SearchButton,
  Table,
  TableHeader,
  TableBody,
  Item,
  ChartBox,
  ChartBarsBox,
  BarBox,
  Bar,
  ChartX,
  Message,
  ValidateExhibition,
  Top,
  TableValidate,
  ValidateHeader,
  ValidateBody,
} from "./styles";
import { isAuthAdmin } from "../../../../services/auth";
import { systemLogs } from "../../../../services/system_logs";

toast.configure();
const AnalyticStatusCurso = () => {
  const [searchedCourse, setSearchedCourse] = useState("");

  const [contagemRegistros, setContagemRegistros] = useState(null);
  const [dataInicio, setDataInicio] = useState(null);
  const [dataFim, setDataFim] = useState(null);

  const [totalIntermitente, setTotalIntermitente] = useState(null);
  const [totalExpiravel, setTotalExpiravel] = useState(null);
  const [dadosExpiraveis, setDadosExpiraveis] = useState([]);
  const [statuses, setStatuses] = useState([]);

  useEffect(() => {
    systemLogs("analytic/StatusCurso", "listou os cursos");
    setDataInicio(
      new Date(new Date().getFullYear(), 0, 1).toISOString().split("T")[0]
    );
    setDataFim(new Date().toISOString().split("T")[0]);
  }, []);

  const getAnalyticData = useCallback(async () => {
    const params = {};

    if (dataInicio) {
      params.dataInicio = dataInicio;
    }

    if (dataFim) {
      params.dataFim = dataFim;
    }

    api
      .get(`/admin/pessoas_curso_online/analise/${searchedCourse}`, { params })
      .then((response) => {
        const dataReturned = response.data.data_status;
        // setContagemRegistros(dataReturned);
        setStatuses(response.data.statuses);
      })
      .catch((err) => console.error(err));

    api
      .get(`/admin/pessoa_curso_online/validade/${searchedCourse}`, { params })
      .then((response) => {
        const data = response.data;

        setTotalIntermitente(data.totalSemDataLimite);
        setTotalExpiravel(data.totalExpiravel);
        setDadosExpiraveis(data?.dadosExpiraveis?.rows || []);
      })
      .catch((err) => console.error(err));
  }, [dataInicio, dataFim, searchedCourse]);

  const calcPercent = (percent) => {
    const total = contagemRegistros?.registrosTotais;
    return (percent * 100) / total;
  };

  const diffInDays = (date, validade) => {
    const dt1 = new Date(date);
    const dt2 = new Date();
    const passedDays = Math.floor(
      (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
        Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
        (1000 * 60 * 60 * 24)
    );
    return validade - passedDays;
  };

  return (
    <>
      <Menu />
      <SearchBarBox>
        <SearchInput
          placeholder={"Pesquise pelo id do curso"}
          onChange={(e) => setSearchedCourse(e.target.value)}
          onKeyUp={(e) => e.key === "Enter" && getAnalyticData()}
          type={"number"}
          value={searchedCourse}
        />
        <SearchButton onClick={getAnalyticData}>
          <FaSearch />
        </SearchButton>
      </SearchBarBox>
      <PeriodContainer>
        <fieldset>
          <label>Data Inicio</label>
          <input
            type="date"
            value={dataInicio}
            onChange={(e) => setDataInicio(e.target.value)}
          />
        </fieldset>
        <fieldset>
          <label>Data Fim</label>
          <input
            type="date"
            value={dataFim}
            onChange={(e) => setDataFim(e.target.value)}
          />
        </fieldset>
      </PeriodContainer>
      {statuses.length ? (
        <>
          <Table>
            <TableHeader columnNumber={7}>
              <Item> Registros Totais </Item>
              <Item> Confirmação de Pagamento </Item>
              <Item> Não Iniciado </Item>
              <Item> Em Andamento </Item>
              <Item> Concluido </Item>
              <Item> Estorno </Item>
            </TableHeader>
            <TableBody columnNumber={7}>
              {statuses.map((status) => (
                <Item> {status.value} </Item>
              ))}
            </TableBody>
          </Table>
          <ChartBox>
            <ChartBarsBox>
              {statuses.map((status) => (
                <BarBox>
                  <Bar percent={status.percentage}>{status.percentage}%</Bar>
                </BarBox>
              ))}
            </ChartBarsBox>
            <ChartX>
              <Item> Confirmação de Pagamento </Item>
              <Item> Não Iniciado </Item>
              <Item> Em Andamento </Item>
              <Item> Concluido </Item>
              <Item> Estorno </Item>
            </ChartX>
          </ChartBox>
          <ValidateExhibition>
            <Top>
              <Item> Total com Acesso Intermitente: {totalIntermitente} </Item>
              <Item> Total Expirável: {totalExpiravel} </Item>
            </Top>
            <TableValidate>
              <ValidateHeader>
                <Item> Dias até vencimento </Item>
                <Item> Período de Validade </Item>
                <Item> Início </Item>
              </ValidateHeader>

              {dadosExpiraveis
                .sort(
                  (a, b) =>
                    diffInDays(a.data_insert, a.validade) -
                    diffInDays(b.data_insert, b.validade)
                )
                .map((item, key) => (
                  <ValidateBody>
                    <Item key={key}>
                      {diffInDays(item.data_insert, item.validade)}
                    </Item>
                    <Item key={key}> {item.validade} </Item>
                    <Item key={key}> {convertDate(item.data_insert)} </Item>
                  </ValidateBody>
                ))}
            </TableValidate>
          </ValidateExhibition>
        </>
      ) : (
        <Message> Procure pelo ID do curso para ter um relatório </Message>
      )}
    </>
  );
};

export default AnalyticStatusCurso;
